export default function DiamondIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      className={className}
    >
      <path d="M1.40869 11.9243C0.777832 11.2935 0.459635 10.6571 0.454102 10.0151C0.448568 9.36768 0.76123 8.72575 1.39209 8.08936L8.09082 1.39893C8.72168 0.768066 9.35807 0.455404 10 0.460938C10.6475 0.466471 11.2894 0.787435 11.9258 1.42383L18.583 8.08105C19.2139 8.71745 19.5321 9.35938 19.5376 10.0068C19.5431 10.6543 19.2305 11.2907 18.5996 11.916L11.9092 18.6147C11.2783 19.2401 10.6392 19.55 9.9917 19.5444C9.34977 19.5444 8.71061 19.2262 8.07422 18.5898L1.40869 11.9243ZM2.63721 10.8535L9.15332 17.3696C9.42448 17.6408 9.70117 17.7764 9.9834 17.7764C10.2712 17.7819 10.5589 17.6408 10.8467 17.353L17.3462 10.8535C17.634 10.5713 17.7751 10.2891 17.7695 10.0068C17.764 9.71908 17.6257 9.43685 17.3545 9.16016L10.8384 2.65234C10.5617 2.37565 10.2822 2.2373 10 2.2373C9.71777 2.23177 9.43278 2.37288 9.14502 2.66064L2.64551 9.15186C2.35775 9.43962 2.21663 9.72461 2.22217 10.0068C2.2277 10.2891 2.36605 10.5713 2.63721 10.8535Z" />
    </svg>
  );
}
